/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { FieldHeading } from '@api';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { getFormValues } from 'redux-form';
import { IshState } from 'src/js/services/IshState';
import { replaceWithNl } from '../../common/utils/HtmlUtils';
import FieldFactory, { toFormKey } from '../../components/form/FieldFactory';

interface Prop {
  heading: FieldHeading;
  allHeadings: FieldHeading[];
  touch?: (field) => void;
  onChangeSuburb?: (item) => void;
  form?: string;
  dispatch?: Dispatch;
}

export const HeadingComp = (
  {
    heading, allHeadings, touch, onChangeSuburb, form, dispatch
  }: Prop) => {

  const values = useSelector<IshState>(state => getFormValues(form)(state))

  const isVisible = (field) => {
    if (field.relatedFieldKey) {
      for (const heading of allHeadings) {
        for (const  [index,headingField] of heading.fields.entries()) {
          if (values && headingField.key === field.relatedFieldKey) {
            let targetFiledValue = values[toFormKey(headingField.key,index)];

            switch (headingField.dataType) {
              case 'ENUM': {
                targetFiledValue = targetFiledValue?.key;
                break;
              }
              case 'BOOLEAN':
              case 'MAILINGLIST': {
                targetFiledValue = targetFiledValue?.toString();
                break;
              }
            }

            if (field.relatedFieldExpectedValue === '*') {
              return ![undefined,null].includes(targetFiledValue)
            }
            if (field.relatedFieldExpectedValue !== '*') {
              return targetFiledValue === field.relatedFieldExpectedValue
            }
          }
        }
      }
      return field.relatedFieldExpectedValue === field.relatedFieldValue;
    }
    return true;
  }

  const renderedFields = heading.fields.map((field, i) => {
    return isVisible(field) && (
      <FieldFactory
        key={i}
        field={field}
        index={i}
        onBlurSelect={touch}
        onChangeSuburb={onChangeSuburb}
        form={form}
        dispatch={dispatch}
      />
    )
  }).filter(f => f);

  return renderedFields.length ? (
    <fieldset className="field-wrapper heading-wrapper">
      {heading.name
        && (
          <legend
            style={{ whiteSpace: 'pre-line' }}
          >
            {replaceWithNl(heading.name)}
          </legend>
        )}
      {heading.description
        && (
          <div
            className="message"
            dangerouslySetInnerHTML={{ __html: replaceWithNl(heading.description) }}
            style={{ whiteSpace: 'pre-line' }}
          />
        )}
      {renderedFields}
    </fieldset>
  ) : null;
}

export default HeadingComp;
